import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Team } from '../../types/Team/Team.type';

interface TeamsMultiSelectProps {
  teams: Team[];
  value: number[];
  onChange: (value: number[]) => void;
  label?: string;
}

function TeamsMultiSelect({ teams, value, onChange, label = 'Select teams' }: TeamsMultiSelectProps) {
  const teamNameById = (id: number) => teams.find((team) => team.id === id)?.name ?? '';

  const handleChange = (event: SelectChangeEvent<number[]>) => {
    onChange(event.target.value as number[]);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id='select-teams-label' sx={{ fontSize: '14px' }}>
        {label}
      </InputLabel>
      <Select
        labelId='select-teams-label'
        multiple
        value={value}
        label={label}
        onChange={handleChange}
        renderValue={(selected) => (selected as number[]).map(teamNameById).filter(Boolean).join(', ')}
      >
        {teams.map((team) => (
          <MenuItem key={team.id} value={team.id}>
            <Checkbox
              size='small'
              checked={value.includes(team.id)}
              disableRipple
              sx={{ padding: '4px 9px 4px 0px' }}
            />
            <ListItemText
              primary={team.name}
              sx={{
                '.MuiListItemText-primary': { fontSize: '14px' },
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default TeamsMultiSelect;
